/* eslint-disable */
export const navigatorError = () => {
  try {
    if (typeof navigator !== 'undefined' && navigator?.connection) {
      console.info('<=====NSTATUS=====>', navigator?.onLine)
      console.info(`Effective network type: ${navigator?.connection?.effectiveType}`)
      console.info(`Downlink Speed: ${navigator?.connection?.downlink}Mb/s`)
      console.info(`Round Trip Time: ${navigator?.connection?.rtt}ms`)
    } else {
      console.info('Navigator Connection API not supported')
    }
  } catch (error) {
    return false
  }
}
